/**
 * Handles image loading failures by trying the proxy before showing fallback.
 * 
 * Usage on any <img> tag:
 *   <img
 *     src={article.image_url || "/fallback.jpg"}
 *     referrerPolicy="no-referrer"
 *     onError={(e) => handleImageError(e, article.image_url)}
 *   />
 */
export const handleImageError = (e, originalUrl) => {
    const img = e.target;

    // If we already tried the proxy, give up and show fallback
    if (img.dataset.triedProxy === "true") {
        img.src = "/fallback.jpg";
        return;
    }

    // If there's no original URL, go straight to fallback
    if (!originalUrl) {
        img.src = "/fallback.jpg";
        return;
    }

    // Mark that we're trying the proxy now
    img.dataset.triedProxy = "true";
    img.src = `${process.env.REACT_APP_API_URL}/proxy/image?url=${encodeURIComponent(originalUrl)}`;
};

/**
 * Pick the best image_url to represent a cluster in a listing card.
 *
 * The listing components used to hard-code `articles[0].image_url`,
 * but article[0] often comes from a source that didn't expose an
 * image in its RSS (or whose image was cleared by Step 1.5 of the
 * clustering pipeline). When that happens the card falls back to
 * the LajmAI placeholder even though articles[1..N] in the same
 * cluster have perfectly good images. This helper walks the
 * cluster and returns the first non-empty image_url it finds.
 */
export const pickClusterImage = (articles) => {
    if (!Array.isArray(articles)) return "";
    const found = articles.find(a => a && a.image_url);
    return found ? found.image_url : "";
};

